<template>
  <DatatableReportV3
    id="members-table"
    title="By Program"
    download-url="/reports/members"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";
import { customerClassificationColumns } from "@/lib/customerTypes";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    // The default sort is by position, so it moves with the classification
    // columns to stay on the same column.
    const classificationColumns = customerClassificationColumns();

    return {
      config: {
        responsive: true,
        order: [[1 + classificationColumns.length, "asc"]],
        columns: [
          ...classificationColumns,
          {
            data: "customer",
            aggregateTitle: "Distinct Customers",
            responsivePriority: 1
          },
          {
            data: "membership_status",
            responsivePriority: 2,
            title: "Member Status",
            filterName: "membership_status",
            searchable: false
          },
          {
            data: "program",
            filterName: "program",
            searchable: false,
            responsivePriority: 3
          },
          {
            data: "program_status",
            title: "Program Status",
            filterName: "membership_program_status",
            orderable: false,
            searchable: false,
            responsivePriority: 4
          },
          {
            data: "payment_method_on_file",
            responsivePriority: 6,
            title: "Payment Method on File",
            filterName: "payment_method_on_file",
            orderable: false,
            searchable: false
          },
          { data: "customer_email", title: "Email", responsivePriority: 12 },
          { data: "customer_phone", title: "Phone", responsivePriority: 7 },
          {
            data: "tags",
            title: "Tags",
            orderable: false,
            searchable: false,
            responsivePriority: 11
          },
          {
            data: "location_name",
            title: "Location Name",
            responsivePriority: 13
          },
          { data: "address", title: "Billing Address", responsivePriority: 14 },
          { data: "zipcode", title: "Zip Code", responsivePriority: 15 },
          {
            data: "renewal_type",
            responsivePriority: 9,
            title: "Renewal Type",
            filterName: "renewal_type",
            orderable: false,
            searchable: false
          },
          {
            data: "since",
            filterName: "starts_on",
            searchable: false,
            responsivePriority: 10
          },
          {
            data: "renews_at",
            title: "Next Billing Date",
            searchable: false,
            responsivePriority: 5
          },
          {
            data: "ends_on",
            title: "Ends On",
            searchable: false,
            responsivePriority: 8
          }
        ],
        vueComponents: [
          {
            rootId: "tag-list-vue",
            component: TagList
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Members" });
  }
};
</script>

<style lang="scss" scoped></style>
